import baseAPI from '@/http'

const router = 'api/vocacao'

export const vocacoesApi = {
    create: (vocacao) => baseAPI.post(router, vocacao),
    update: (vocacao) => baseAPI.put(router, vocacao),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    list: () => baseAPI.get(router),
    find: (id) => baseAPI.get(`${router}/${id}`),
    getByMunicipio: (municipioId) => baseAPI.get(`${router}/obter-vocacoes-por-municipio/${municipioId}`),

}
